import React from "react";
import Layout from "components/Layout";
import MyPageForm from "./component/MyPageForm";

function MyPage() {
  return (
    <Layout title="마이 페이지">
      <MyPageForm />
    </Layout>
  );
}

export default MyPage;
